"use client";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { usePageTitle } from "@/lib/usePageTitle";

const lastUpdated = "January 19, 2026";

export default function PrivacyPolicyPage() {
  usePageTitle("Privacy Policy");
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Privacy policy</h1>
            <p className="text-sm text-muted-foreground">Last updated: {lastUpdated}</p>
          </div>
          <div className="space-y-4 text-muted-foreground">
            <p>
              This Privacy Policy explains how BlockyNetworks (operated by Favela Tech LLC) collects, uses, and shares
              information when you use the platform.
            </p>
            <p>
              We collect account details (such as email, username, and authentication identifiers), organization and server
              data, posts or messages you submit, device information, and usage analytics needed to operate the platform.
            </p>
            <p>
              We use this information to provide the platform, prevent fraud and abuse, provide customer support, and
              improve the service.
            </p>
            <p>
              We do not sell personal information. We share data with trusted service providers for authentication,
              analytics, hosting, and monitoring, and when required by law or to enforce our terms.
            </p>
            <p>
              Data is retained only as long as needed for legitimate business purposes, including compliance and dispute
              resolution. You can request access, correction, or deletion by contacting support. Some records must be kept
              for legal or accounting reasons.
            </p>
            <p>
              This service is not directed to children under 13. If you believe a child has provided personal information,
              contact us so we can take appropriate action.
            </p>
            <p>
              For privacy questions, contact support@blockynetworks.com.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
